import _ from 'lodash'

/**
 * Returns a new array of filters without any duplicates with the same
 * drilldownActionId.
 *
 * @param {ApiDatasetFilter[]}
 */
function uniqueDrilldownActionId (allFilters) {
	return allFilters.reduce((filters, currentFilter) => {
		if (_.isNil(currentFilter.drilldownActionId)) {
			// If there's no drilldownActionId, then this filter wasn't created
			// as part of a drilldown, so we keep it
			filters.push(currentFilter)
		}

		if (!_.find(filters, f => f.drilldownActionId == currentFilter.drilldownActionId)) {
			// Only keep this filter if there isn't already one with the same
			// drilldownActionId
			filters.push(currentFilter)
		}

		return filters
	}, [])
}

export default uniqueDrilldownActionId

uniqueDrilldownActionId.__filename__ = 'dashboards/widgets/unique-drilldown-action-id.js'
